/**
 * Export a list of objects to a CSV file download.
 * @param {Object[]} rows   Array of flat objects
 * @param {string[]} columns Column keys to include (in order)
 * @param {Object}  headers  Map of key → display label
 * @param {string}  filename Desired filename (without .csv)
 */
export const exportToCsv = (rows, columns, headers, filename = 'export') => {
  const header = columns.map((c) => `"${(headers[c] || c).replace(/"/g, '""')}"`).join(',');
  const lines = rows.map((row) =>
    columns
      .map((c) => {
        const val = row[c];
        if (val == null) return '""';
        const str = String(val).replace(/"/g, '""');
        return `"${str}"`;
      })
      .join(',')
  );

  const csv = [header, ...lines].join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
